<div   class="setpasswordContainer">
   
    <!-- <div  > -->
    <mat-card class="mat-elevation-z2" [ngClass]="{'loginCard ': !(isHandset$ | async) , 'loginCardHandset': (isHandset$ | async) }" >
     
      <form id="formContainer"  [formGroup]="setPasswordForm" >
        <div  [ngClass]="{'headerImageWeb': !(isHandset$ | async) , 'headerImageHandset': (isHandset$ | async) }" class="headerFlex" >
          <img src="assets/logo.png" alt="mdr logo" >
      </div>
      <div style="display: flex; color: #000000; opacity: 0.8; padding-top: 16px;" class="mat-display-4">
        Vanuatu Medical Disability Registry
       </div>
       <div style="padding-top: 20px; color: #000000; opacity: 0.8;" class="mat-subheading-1">
        Create New Password
       </div>
        <mat-form-field class="example-full-width" appearance="outline" style="width: 80%; padding-top: 24px;">
          <mat-label>Password</mat-label>
          <input (focus)="this.setPasswordForm.controls['password'].markAsTouched();" (keydown.space)="$event.preventDefault()" matInput maxlength="15" #passwordInput 
          [type]="hide ? 'password' : 'text'" formControlName="password" (keypress)="keyPressPassword($event)">
          <div  style="cursor:pointer" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"  *ngIf="!(setPasswordForm.controls['password'].invalid && setPasswordForm.controls['password'].touched)">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </div>
          <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(setPasswordForm.controls['password'].invalid && setPasswordForm.controls['password'].touched)" >
            <mat-icon style="color: red;">   
              <span class="material-icons-outlined">
                error_outline
              </span>
            </mat-icon>
          </div>
          <mat-hint class="error-hint"  [ngClass]="{'error-hint': (setPasswordForm.controls['password'].hasError('invalidPassword') 
          && setPasswordForm.controls['password'].touched) , 'normal-hint': !(setPasswordForm.controls['password'].hasError('invalidPassword') 
          && setPasswordForm.controls['password'].touched) }">8-15 characters, with at least one number, special, uppercase, and lowercase characters
          </mat-hint>
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" style="margin-top: 12px;" style="width: 80%; padding-top: 16px;">
            <mat-label>Confirm Password</mat-label>
            <input (focus)="this.setPasswordForm.controls['confirmPassword'].markAsTouched();" (keydown.space)="$event.preventDefault()" matInput maxlength="15" #passwordInput 
            [type]="confirmhide ? 'password' : 'text'" formControlName="confirmPassword" (keypress)="keyPressPassword($event)">
            <div  style="cursor:pointer" mat-icon-button matSuffix (click)="confirmhide = !confirmhide" [attr.aria-label]="'Hide password'" *ngIf="!(setPasswordForm.controls['confirmPassword'].invalid && setPasswordForm.controls['confirmPassword'].touched)">
              <mat-icon>{{confirmhide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </div>
            <div  style="cursor:pointer" mat-icon-button matSuffix *ngIf="(setPasswordForm.controls['confirmPassword'].invalid && setPasswordForm.controls['confirmPassword'].touched)" >
              <mat-icon style="color: red;">   
                <span class="material-icons-outlined">
                  error_outline
                </span>
              </mat-icon>
            </div>
            <mat-hint class="error-hint" 
            *ngIf="setPasswordForm.controls['confirmPassword'].hasError('mismatch') && !(setPasswordForm.controls['confirmPassword'].hasError('invalidPassword') )">Password do not match
            </mat-hint>
          </mat-form-field>
        <div class="action-area">
        
          <button  [ngClass]="{'login-btn': !setPasswordForm.invalid ,'login-btn-disabled':setPasswordForm.invalid}"  [disabled]="setPasswordForm.invalid" (click)="onSave()" 
          mat-raised-button> 
          <span [ngClass]="{'mat-button': !setPasswordForm.invalid ,'mat-button-disabled':setPasswordForm.invalid}" >SAVE</span>
          </button>

          <div class="cancel"><span class="mat-body-2"  (click)="cancel()">CANCEL</span></div>
        </div>
    
    
    </form>
    </mat-card>
    </div>
    